import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import EnquiryPage from '../pages/EnquiryPage/EnquiryPage';
import WhatsAppTemplatePage from '../pages/WhatsAppTemplatePage/WhatsAppTemplatePage';
// Imports removed

import './Dashboard.css';

const Dashboard = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState('enquiry');
  // useModal removed


  // Update active menu based on navigation state or route
  useEffect(() => {
    if (location.state?.activeMenu) {
      setActiveMenu(location.state.activeMenu);
    }
  }, [location.state]);

  const renderContent = () => {
    if (activeMenu === 'enquiry') {
      return <EnquiryPage />;
    } else if (activeMenu === 'whatsapp-templates') {
      return <WhatsAppTemplatePage />;
    }
    return <EnquiryPage />;
  };

  const tabs = [
    { id: 'enquiry', label: 'Leads' },
    { id: 'whatsapp-templates', label: 'WhatsApp Templates' },
  ];

  return (
    <div className="flex flex-col h-full bg-slate-50">
      <div className="bg-white border-b px-6 py-3 mb-4 flex items-center shadow-sm">
        <h1 className="text-xl font-semibold mr-8 text-slate-800">Lead Management</h1>
        <div className="flex space-x-2">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveMenu(tab.id)}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${activeMenu === tab.id
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <main className="flex-1 overflow-auto">
        {renderContent()}
      </main>

      {/* Modal removed */}

    </div>
  );
};

export default Dashboard;
